<app-header></app-header>
<app-profile-header></app-profile-header>
<app-right-side></app-right-side>
<div class="container">
    <div class="row">
        <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12" style="top:-100px">
            <div class="ui-block responsive-flex" style="background-color: var(--backgroundpost-color); color: var(--text-color);">
                <div class="ui-block-title">
                    <div class="h6 title"> Photo Gallery ( {{photos.length}} )</div>
                </div>
            </div>
        </div>
        <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"  style="top:-100px">
            <div class="row">
                <div *ngFor="let item2 of photos" class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3">
                    <div>
                        <img src="{{item2.image}}" class="img1">
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</div>